import { IApplicationState } from '../../types/store';

export const selectBlackFridaySettings = (state: IApplicationState) => {
  return state.blackFridaySettings;
};
